import { Container, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams } from 'react-router'

import AppFooter from '../components/layout/AppFooter'
import AppHeader from '../components/layout/AppHeader'
import Shell from '../components/layout/Shell'
import {
  CONTACT_VERIFICATION_ENTRY_TOKEN_KEY,
  CONTACT_VERIFICATION_PROCESS_STATUS_KEY,
  CONTACT_VERIFICATION_TOKEN_KEY,
  getItemFromLS,
} from '../core/api'

const SUPPORTED_PROCESS_STATUSES = new Set(['pending_validation', 'complete'])

export default function VerificationStatusPage() {
  const { t } = useTranslation()
  const { verificationToken = '' } = useParams()
  const hasActiveSession =
    getItemFromLS(CONTACT_VERIFICATION_ENTRY_TOKEN_KEY) === verificationToken &&
    getItemFromLS(CONTACT_VERIFICATION_TOKEN_KEY)
  const processStatus = getItemFromLS(CONTACT_VERIFICATION_PROCESS_STATUS_KEY)

  if (!hasActiveSession) {
    return <Navigate to={`/verify/${verificationToken}`} replace />
  }

  if (!processStatus || !SUPPORTED_PROCESS_STATUSES.has(processStatus)) {
    return <Navigate to={`/verify/${verificationToken}/review`} replace />
  }

  return (
    <Shell>
      <AppHeader />
      <Container maxWidth="sm" sx={{ py: { xs: 3, md: 5 }, flexGrow: 1 }}>
        <Paper variant="outlined" sx={{ p: { xs: 3, md: 4 } }}>
          <Stack spacing={2}>
            <Typography variant="h3">{t(`verification.processStatus.${processStatus}.title`)}</Typography>
            <Typography color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
              {t(`verification.processStatus.${processStatus}.message`)}
            </Typography>
          </Stack>
        </Paper>
      </Container>
      <AppFooter />
    </Shell>
  )
}
